import { useRouter } from '../../../../../utils/routing';

const useChangeLanguage = () => {
  const router = useRouter();
  const change = (lang: string) => {
    const linkTag = document.querySelector(
      `link[rel="alternate"][hreflang="${lang}"]`,
    );
    if (linkTag) {
      const url = linkTag.getAttribute('href');
      if (url) {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname.replace(`/${lang}`, '');
        const path = pathname + urlObj.search;
        router.push(path, { locale: lang });
      }
    } else {
      console.warn(`No alternate link tag found for language: ${lang}`);
      router.push('/', { locale: lang });
    }
  };

  return change;
};

export default useChangeLanguage;
